const DaswatchSvgColor = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16C10 12.6863 12.6863 10 16 10C19.3137 10 22 12.6863 22 16ZM24 16C24 20.4183 20.4183 24 16 24C11.5817 24 8 20.4183 8 16C8 11.5817 11.5817 8 16 8C20.4183 8 24 11.5817 24 16ZM17 12V15.5858L18.7071 17.2929L17.2929 18.7071L15.2929 16.7071L15 16.4142V16V12H17Z"
      fill="#656565"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 4H20.4998L21.7738 9.09588C20.211 7.78758 18.1975 7 15.9999 7C13.8024 7 11.7888 7.78761 10.226 9.09595L11.5 4ZM10.226 22.9041L11.5 28H20.4998L21.7738 22.9041C20.211 24.2124 18.1975 25 15.9999 25C13.8024 25 11.7888 24.2124 10.226 22.9041Z"
      fill="#A1A1A1"
    />
  </svg>
);
export default DaswatchSvgColor;
